export * from '@devstroupe/services/init-app/init-app.service';
